import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    CheckStockEntryforBackDatedTransaction,
    CheckStockEntryforBackDatedTransactionSuccess,
    CheckStockEntryForFirstTransaction,
    CheckStockEntryForFirstTransactionSuccess
} from '../../../store/actions';
import { customAlert } from '../../../CustomAlert/ConfirmDialog';

const useCheckStockEntry = (commonPartyDropSelect) => {
    const dispatch = useDispatch();

    const pendingActionRef = useRef(null);
    const [isCheckPending, setIsCheckPending] = useState(false);

    const { StockEnteryForFirstYear, StockEnteryForBackdated } = useSelector((state) => ({
        StockEnteryForFirstYear: state.StockEntryReducer.StockEnteryForFirstYear,
        StockEnteryForBackdated: state.StockEntryReducer.StockEnteryForBackdated,
    }));

    // ✅ Cleanup on unmount — prevents stale store state affecting next render
    useEffect(() => {
        return () => {
            dispatch(CheckStockEntryForFirstTransactionSuccess({ status: false }));
            dispatch(CheckStockEntryforBackDatedTransactionSuccess({ status: false }));
        };
    }, []);

    useEffect(() => {
        if (!isCheckPending) return;

        const firstYearReady = StockEnteryForFirstYear?.StatusCode === 200 || StockEnteryForFirstYear?.StatusCode === 400;
        const backdatedReady = StockEnteryForBackdated?.StatusCode === 200 || StockEnteryForBackdated?.StatusCode === 400;

        if (!firstYearReady || !backdatedReady) return;

        setIsCheckPending(false);

        const validationChecks = [StockEnteryForBackdated, StockEnteryForFirstYear];
        for (const check of validationChecks) {
            if (check.Status === true && check.StatusCode === 400) {
                customAlert({
                    Type: 3,
                    Message: JSON.stringify(check.Message),
                });
                pendingActionRef.current = null;
                // ✅ Reset immediately on failure
                dispatch(CheckStockEntryForFirstTransactionSuccess({ status: false }));
                dispatch(CheckStockEntryforBackDatedTransactionSuccess({ status: false }));
                return;
            }
        }

        if (pendingActionRef.current) {
            const { action, params, callback } = pendingActionRef.current;
            pendingActionRef.current = null;
            if (callback) {
                callback();
            } else if (action) {          // ✅ guard before dispatching
                dispatch(action(params));
            } else {
                console.error("Actionhandler: neither action nor callback was provided");
            }
        }

        // ✅ Reset immediately after success too
        dispatch(CheckStockEntryForFirstTransactionSuccess({ status: false }));
        dispatch(CheckStockEntryforBackDatedTransactionSuccess({ status: false }));

    }, [StockEnteryForBackdated, StockEnteryForFirstYear, isCheckPending]);


    const Actionhandler = ({ transactionDate, action, params, callback }) => {
        console.trace("ACTIONHANDLER CALLED", transactionDate);
        if (!commonPartyDropSelect?.value || commonPartyDropSelect.value <= 0) return;

        // ✅ Always reset store AND local state before new check
        pendingActionRef.current = null;
        setIsCheckPending(false);

        setTimeout(() => {  // ✅ Let state settle before dispatching new checks
            pendingActionRef.current = {
                action,
                params,
                callback,
                transactionDate
            };
            dispatch(CheckStockEntryForFirstTransactionSuccess({ status: false }));
            dispatch(CheckStockEntryforBackDatedTransactionSuccess({ status: false }));

            const jsonBody = JSON.stringify({
                "FromDate": transactionDate,
                "PartyID": commonPartyDropSelect.value,
            });

            const jsonBodyForBackdatedTransaction = JSON.stringify({
                "TransactionDate": transactionDate,
                "PartyID": commonPartyDropSelect.value,
            });

            dispatch(CheckStockEntryForFirstTransaction({ jsonBody }));
            dispatch(CheckStockEntryforBackDatedTransaction({ jsonBody: jsonBodyForBackdatedTransaction }));

            setIsCheckPending(true);
        }, 0);
    };

    return { Actionhandler };
};

export default useCheckStockEntry;